import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  withProps,
  pure,
  defaultProps,
  setPropTypes
} from 'recompose';

import { StyledWrapperTabs, StyledUlTabs, StyleActiveContent } from './style';
import Tab from './Tab';

const Tabs = ({ className, vertical, activeTab, tabElement }) => (
  <StyledWrapperTabs className={className} vertical={vertical}>
    <StyledUlTabs>{tabElement}</StyledUlTabs>
    <StyleActiveContent>{activeTab}</StyleActiveContent>
  </StyledWrapperTabs>
);

const enhance = compose(
  defaultProps({
    activeIndex: 0
  }),
  withProps(({ children, activeIndex }) => {
    const activeTab = React.Children.toArray(children)[activeIndex].props
      .children;
    return {
      activeTab,
      tabElement: children.map((item, index) =>
        index === activeIndex
          ? React.cloneElement(item, {
              content: activeTab
            })
          : item
      )
    };
  }),
  setPropTypes({
    className: PropTypes.string,
    activeIndex: PropTypes.number,
    vertical: PropTypes.bool,
    tabElement: PropTypes.arrayOf(PropTypes.node),
    activeTab: PropTypes.node
  }),
  pure
)(Tabs);

export { Tab, enhance as Tabs };
